import { useQuery } from "@tanstack/react-query";
import { loadLocations } from "../../../apis/search";
import { authAtom } from "../../auth/atoms";
import { useAtomValue } from "jotai";

export function useBrands({
  latitude,
  longitude,
  enabled,
}: {
  latitude: number;
  longitude: number;
  enabled: boolean;
}) {
    const auth = useAtomValue(authAtom);
  const accessToken = auth?.data?.accessToken;
  return useQuery({
    queryKey: ["brands", latitude, longitude],
    queryFn: () => loadLocations(accessToken, {
        latitude: latitude.toString(),
        longitude: longitude.toString(),
        accessibilities: "",
        showVenueOptions: "All",
        addinfo: "",
        placesToReplaceString: "",
        searchThisAreaClicked: "no",
        zoom: "16", // Match home page search zoom
        new_map: "1",
        tagging_mode: "off",
        progressive_update: "yes",
        saved_place_id: "",
        saved_place_user_id: "",
        saved_place_sortby: "",
        unixTimestamp: Math.floor(Date.now() / 1000),
        types: "",
        search: "",
        userlatitude: latitude.toString(),
        userlongitude: longitude.toString(),
        search_type: "brands",
        search_value: "",
        userToken: accessToken,
      }),
      enabled,
    });
}